export default __webpack_public_path__ + "static/media/vip3.3414c2c5.webp";